import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    // InputLabel,
    Grid,
    MenuItem,
    Radio,
    RadioGroup,
    TextField,
    Divider,
} from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import {
    EnumTipoProducto,
    EnumGrupoProducto,
    EnumIntervaloProducto,
    EnumVisibilidadProducto,
} from "../../../../settings/enumConfig";
import MeditocModal from "../../../utils/MeditocModal";
import { useCatalogo } from "../../../../context/CatalogoContext";
import { useProducto } from "../../../../context/ProductoContext";

export default function FormProducto() {
    const { entCatalogos } = useCatalogo();
    const {
        productoSeleccionado,
        modalOpenFormProducto,
        formProducto,
        handleOpenFormProducto,
        handleChangeFormProductoText,
        handleChangeFormProductoUDec,
        handleChangeFormProductoUInt,
        // handleChangeFormProductoCheck,
        handleChangeFormProductoCheckPremium,
        handleChangeFormProductoGrupoProductos,
        handleChangeFormProductoCheckComercial,
        handleChangeFormProductoTipoProducto,
        handleSubmitFormProducto,
    } = useProducto();

    const {
        rdTipoProducto,
        chkComercial,
        chkPremium,
        txtNombreProducto,
        txtNombreCorto,
        txtDescripcion,
        slcGrupoProducto,
        txtCosto,
        txtMesesVigencia,
        slcIcono,
        txtPrefijoFolio,
        slcIntervalo,
        slcVisible,
        txtCantidadOrientacion,
        txtCantidadAsistenciaPsicologica,
        txtCantidadEspecialistaPsicologo,
    } = formProducto;

    return (
        <MeditocModal
            title={productoSeleccionado.iIdProducto === 0 ? "Nuevo producto" : "Editar producto"}
            setopen={handleOpenFormProducto}
            okfunc={handleSubmitFormProducto}
            open={modalOpenFormProducto}
            okmessage="Guardar"
            size="small"
            form
        >
            <Grid container spacing={3}>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtNombreProducto"
                        label={txtNombreProducto.label}
                        required={txtNombreProducto.required}
                        value={txtNombreProducto.value}
                        error={txtNombreProducto.error}
                        helperText={txtNombreProducto.error && txtNombreProducto.message}
                        onChange={handleChangeFormProductoText}
                        placeholder={txtNombreProducto.placeholder}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        autoFocus
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtNombreCorto"
                        label={txtNombreCorto.label}
                        required={txtNombreCorto.required}
                        value={txtNombreCorto.value}
                        error={txtNombreCorto.error}
                        helperText={txtNombreCorto.error && txtNombreCorto.message}
                        onChange={handleChangeFormProductoText}
                        placeholder={txtNombreCorto.placeholder}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="txtDescripcion"
                        label={txtDescripcion.label}
                        required={txtDescripcion.required}
                        value={txtDescripcion.value}
                        error={txtDescripcion.error}
                        helperText={txtDescripcion.error && txtDescripcion.message}
                        onChange={handleChangeFormProductoText}
                        placeholder={txtDescripcion.placeholder}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        multiline
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="slcGrupoProducto"
                        label={slcGrupoProducto.label}
                        required={slcGrupoProducto.required}
                        value={slcGrupoProducto.value}
                        error={slcGrupoProducto.error}
                        helperText={slcGrupoProducto.error && slcGrupoProducto.message}
                        onChange={handleChangeFormProductoGrupoProductos}
                        variant={inputVariant}
                        color={inputColor}
                        disabled={slcGrupoProducto.disabled}
                        fullWidth
                        select
                    >
                        {entCatalogos.catGrupoProducto.map((grupo) => {
                            if (
                                !(
                                    grupo.fiId === EnumGrupoProducto.NutritionalProducts ||
                                    grupo.fiId === EnumGrupoProducto.PsychologyProducts
                                )
                            ) {
                                return (
                                    <MenuItem key={grupo.fiId} value={grupo.fiId}>
                                        {grupo.fsDescripcion}
                                    </MenuItem>
                                );
                            }
                        })}
                    </TextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                    <FormGroup row>
                        <FormControlLabel
                            label={chkComercial.message}
                            control={
                                <Checkbox
                                    name="chkComercial"
                                    checked={chkComercial.value}
                                    disabled={chkComercial.disabled}
                                    onChange={handleChangeFormProductoCheckComercial}
                                />
                            }
                        />
                    </FormGroup>
                </Grid>
                <Grid item xs={12}>
                    <FormControl componet="fieldset">
                        <FormLabel component="legend">{rdTipoProducto.message}</FormLabel>
                        <RadioGroup
                            row
                            name="rdTipoProducto"
                            value={rdTipoProducto.value.toString()}
                            onChange={handleChangeFormProductoTipoProducto}
                        >
                            {entCatalogos.catTipoProducto.map((tipo) => {
                                if (tipo.fiId == EnumTipoProducto.Plan) {
                                    if (
                                        chkComercial.value &&
                                        EnumGrupoProducto.MeditocProducts == slcGrupoProducto.value
                                    ) {
                                        return (
                                            <FormControlLabel
                                                key={tipo.fiId}
                                                disabled={rdTipoProducto.disabled}
                                                value={tipo.fiId.toString()}
                                                control={<Radio />}
                                                label={tipo.fsDescripcion}
                                            />
                                        );
                                    }
                                } else {
                                    return (
                                        <FormControlLabel
                                            key={tipo.fiId}
                                            disabled={rdTipoProducto.disabled}
                                            value={tipo.fiId.toString()}
                                            control={<Radio />}
                                            label={tipo.fsDescripcion}
                                        />
                                    );
                                }
                            })}
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                {rdTipoProducto.value != EnumTipoProducto.Servicio &&
                    EnumGrupoProducto.MeditocProducts === slcGrupoProducto.value && (
                        <Grid item xs={12}>
                            <FormGroup row>
                                <FormControlLabel
                                    label={chkPremium.message}
                                    control={
                                        <Checkbox
                                            name="chkPremium"
                                            checked={chkPremium.value}
                                            disabled={chkPremium.disabled}
                                            onChange={handleChangeFormProductoCheckPremium}
                                        />
                                    }
                                />
                            </FormGroup>
                        </Grid>
                    )}

                {(rdTipoProducto.value == EnumTipoProducto.Membresia ||
                    rdTipoProducto.value == EnumTipoProducto.Plan) && (
                    <Grid item sm={6} xs={12}>
                        <TextField
                            name="slcIntervalo"
                            label={slcIntervalo.label}
                            required={slcIntervalo.required}
                            value={slcIntervalo.value}
                            error={slcIntervalo.error}
                            helperText={slcIntervalo.error && slcIntervalo.message}
                            onChange={handleChangeFormProductoText}
                            variant={inputVariant}
                            color={inputColor}
                            disabled={slcIntervalo.disabled}
                            fullWidth
                            select
                        >
                            {Object.keys(EnumIntervaloProducto).map((EnumKey) => {
                                if (rdTipoProducto.value != EnumTipoProducto.Plan) {
                                    return (
                                        <MenuItem key={EnumKey} value={EnumKey}>
                                            {EnumIntervaloProducto[EnumKey]}
                                        </MenuItem>
                                    );
                                } else {
                                    if (EnumKey.toString() != "day") {
                                        return (
                                            <MenuItem key={EnumKey} value={EnumKey}>
                                                {EnumIntervaloProducto[EnumKey]}
                                            </MenuItem>
                                        );
                                    }
                                }
                            })}
                        </TextField>
                    </Grid>
                )}
                {(rdTipoProducto.value == EnumTipoProducto.Membresia ||
                    rdTipoProducto.value == EnumTipoProducto.Plan) && (
                    <Grid item sm={6} xs={12}>
                        <TextField
                            name="txtMesesVigencia"
                            label={txtMesesVigencia.label}
                            required={txtMesesVigencia.required}
                            value={txtMesesVigencia.value}
                            error={txtMesesVigencia.error}
                            helperText={txtMesesVigencia.error && (txtMesesVigencia.errorplan ? txtMesesVigencia.messageplan : txtMesesVigencia.message)}
                            onChange={handleChangeFormProductoUInt}
                            placeholder={txtMesesVigencia.placeholder}
                            variant={inputVariant}
                            color={inputColor}
                            disabled={txtMesesVigencia.disabled}
                            fullWidth
                        />
                    </Grid>
                )}
                {((EnumGrupoProducto.MeditocProducts == slcGrupoProducto.value && chkComercial.value == true) ||
                    (EnumGrupoProducto.PsychologyProducts == slcGrupoProducto.value && chkComercial.value == true)) && (
                    <Grid item sm={6} xs={12}>
                        <TextField
                            name="slcVisible"
                            label={slcVisible.label}
                            required={slcVisible.required}
                            value={slcVisible.value}
                            error={slcVisible.error}
                            helperText={slcVisible.error && slcVisible.message}
                            onChange={handleChangeFormProductoText}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                            select
                        >
                            {Object.keys(EnumVisibilidadProducto).map((EnumKey) => (
                                <MenuItem key={EnumKey} value={EnumKey}>
                                    {EnumVisibilidadProducto[EnumKey]}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                )}

                {((rdTipoProducto.value == EnumTipoProducto.Membresia) ||
                    rdTipoProducto.value == EnumTipoProducto.Servicio) && (
                    <Grid item xs={12}>
                        <TextField
                            name="txtCantidadOrientacion"
                            label={txtCantidadOrientacion.label}
                            required={txtCantidadOrientacion.required}
                            value={txtCantidadOrientacion.value}
                            onChange={handleChangeFormProductoUInt}
                            placeholder={txtCantidadOrientacion.placeholder}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                        />
                    </Grid>
                )}
                {((rdTipoProducto.value == EnumTipoProducto.Membresia) ||
                    rdTipoProducto.value == EnumTipoProducto.Servicio) && (
                    <Grid item xs={12}>
                        <TextField
                            name="txtCantidadAsistenciaPsicologica"
                            label={txtCantidadAsistenciaPsicologica.label}
                            required={txtCantidadAsistenciaPsicologica.required}
                            value={txtCantidadAsistenciaPsicologica.value}
                            onChange={handleChangeFormProductoUInt}
                            placeholder={txtCantidadAsistenciaPsicologica.placeholder}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                        />
                    </Grid>
                )}
                {(rdTipoProducto.value == EnumTipoProducto.Membresia ||
                    rdTipoProducto.value == EnumTipoProducto.Servicio ||
                    rdTipoProducto.value == EnumTipoProducto.Plan) && (
                    <Grid item xs={12}>
                        <TextField
                            name="txtCantidadEspecialistaPsicologo"
                            label={txtCantidadEspecialistaPsicologo.label}
                            required={txtCantidadAsistenciaPsicologica.required}
                            value={txtCantidadEspecialistaPsicologo.value}
                            onChange={handleChangeFormProductoUInt}
                            placeholder={txtCantidadEspecialistaPsicologo.placeholder}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                        />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtCosto"
                        label={txtCosto.label}
                        required={txtCosto.required}
                        value={txtCosto.value}
                        error={txtCosto.error}
                        helperText={txtCosto.error && txtCosto.message}
                        onChange={handleChangeFormProductoUDec}
                        placeholder={txtCosto.placeholder}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="slcIcono"
                        label={slcIcono.label}
                        required={slcIcono.required}
                        value={slcIcono.value}
                        error={slcIcono.error}
                        helperText={slcIcono.error && slcIcono.message}
                        onChange={handleChangeFormProductoText}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        select
                        SelectProps={{
                            MenuProps: { PaperProps: { style: { maxHeight: 300 } } },
                        }}
                    >
                        {entCatalogos.catIcon.map((icon) => (
                            <MenuItem key={icon.fiId} value={icon.fsDescripcion}>
                                <i
                                    className="icon size-20 color-2"
                                    dangerouslySetInnerHTML={{
                                        __html: `&#x${icon.fsDescripcion};&nbsp;&nbsp;&nbsp;`,
                                    }}
                                />
                                {icon.fsDescripcion}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TextField
                        name="txtPrefijoFolio"
                        label={txtPrefijoFolio.label}
                        required={txtPrefijoFolio.required}
                        value={txtPrefijoFolio.value}
                        error={txtPrefijoFolio.error}
                        helperText={txtPrefijoFolio.error && txtPrefijoFolio.message}
                        onChange={handleChangeFormProductoText}
                        placeholder={txtPrefijoFolio.placeholder}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
